module.exports = __webpack_public_path__ + "static/pic5-8b67db626fc826ba373164c68b8dd5ea.jpg";